export function formatDate(dateString: string | null): string {
    if (!dateString) return '-';

    // 1) Parse the date from the ISO string (interpreting it as UTC)
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-'; // handle invalid date

    // 2) Determine the user’s local timezone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // 3) Format the date/time using German locale but without weekday and timezone
    const germanOptions: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: userTimeZone,
        // Omit weekday and timezoneName to avoid showing them
    };
    const germanFormatter = new Intl.DateTimeFormat('de-DE', germanOptions);
    const germanFormatted = germanFormatter.format(date);

    // 4) Separately format the weekday using a northern language locale
    // Replace 'en-NO' with the appropriate locale code for your "northern" language choice.
    const northernWeekdayFormatter = new Intl.DateTimeFormat('en-NO', {
        weekday: 'long',
        timeZone: userTimeZone
    });
    const northernWeekday = northernWeekdayFormatter.format(date);

    // 5) Combine the weekday with the German-formatted date/time
    const formattedDate = `${northernWeekday}, ${germanFormatted}`;

    // 6) Calculate the time-ago difference using UTC timestamps
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);

    const timeAgo =
        diffMinutes < 1
            ? 'just now'
            : diffMinutes < 60
                ? `${diffMinutes} minutes ago`
                : diffHours < 24
                    ? `${diffHours} hours ago`
                    : `${diffDays} days ago`;

    // 7) Return the final formatted string
    return `${formattedDate} (${timeAgo})`;
}


export function formatDateOnly(dateString: string | null): string {
    if (!dateString) return '-';

    // 1) Parse the date from the ISO string (interpreting it as UTC)
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '-'; // handle invalid date

    // 2) Format the date using the German locale (without time, weekday, or timezone)
    const germanOptions: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    };
    const germanFormatter = new Intl.DateTimeFormat('de-DE', germanOptions);
    const germanFormatted = germanFormatter.format(date);

    // 3) Return the final formatted date (in German)
    return germanFormatted;
}
